import React from 'react';
import { Navigate } from 'react-router-dom';

/**
 * SaasAdminGuard - Protege rutas exclusivas del administrador SaaS de la plataforma.
 * Solo usuarios con isSaasAdmin=true en su userData pueden acceder.
 */
const SaasAdminGuard = ({ children, fallback = null }) => {
  const getUserData = () => {
    try {
      const userData = localStorage.getItem('userData');
      return userData ? JSON.parse(userData) : null;
    } catch (error) {
      console.error('Error al obtener datos del usuario:', error);
      return null;
    }
  };

  const userData = getUserData();

  if (userData?.isSaasAdmin === true) {
    return <>{children}</>;
  }

  if (fallback) {
    return <>{fallback}</>;
  }

  return <Navigate to="/home" replace />;
};

export default SaasAdminGuard;
